module.exports = __webpack_public_path__ + "static/media/room_heater.f47ba7bd.svg";